import React from 'react'
import classNames from 'classnames'
import IconButton from '@material-ui/core/IconButton'
import Snackbar from '@material-ui/core/Snackbar'
import SnackbarContent from '@material-ui/core/SnackbarContent'
import green from '@material-ui/core/colors/green'
import amber from '@material-ui/core/colors/amber'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import CloseIcon from '@material-ui/icons/Close'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import WarningIcon from '@material-ui/icons/Warning'
import withStyles from '@material-ui/core/styles/withStyles'
import { useContext } from 'react'
import { CustomizedSnackbarContext } from '..'

const variantIcon = {
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: ErrorIcon,
  info: InfoIcon,
}

const styles = {
  mySnackbarContent: theme => ({
    success: {
      backgroundColor: green[600],
    },
    error: {
      backgroundColor: theme.palette.error.dark,
    },
    info: {
      backgroundColor: theme.palette.primary.dark,
    },
    warning: {
      backgroundColor: amber[700],
    },
    icon: {
      fontSize: 20,
    },
    iconVariant: {
      opacity: 0.9,
      marginRight: theme.spacing.unit,
    },
    message: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
  customizedSnackbar: theme => ({
    margin: {
      margin: theme.spacing.unit,
    },
  })
}

function MySnackbarContent(props) {
  const { classes, className, message, onClose, variant, ...other } = props
  const Icon = variantIcon[variant]

  return (
    <SnackbarContent
      className={classNames(classes[variant], className)}
      aria-describedby="client-snackbar"
      message={
        <span id="client-snackbar" className={classes.message}>
          <Icon className={classNames(classes.icon, classes.iconVariant)} />
          {message}
        </span>
      }
      action={[
        <IconButton
          key="close"
          aria-label="Close"
          color="inherit"
          className={classes.close}
          onClick={onClose}
        >
          <CloseIcon className={classes.icon} />
        </IconButton>,
      ]}
      {...other}
    />
  )
}

const MySnackbarContentWrapper = withStyles(styles.mySnackbarContent)(MySnackbarContent)

function CustomizedSnackbar(props) {
  const { open, message, variant, close } = useContext(CustomizedSnackbarContext)

  return (
    <CustomizedSnackbarContext.Provider>
      <Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={open}
        autoHideDuration={5000}
        onClose={close}
      >
        <MySnackbarContentWrapper
          onClose={close}
          variant={variant}
          message={message}
        />
      </Snackbar>
    </CustomizedSnackbarContext.Provider>
  )
}

export default withStyles(styles.customizedSnackbar)(CustomizedSnackbar)


// WEBPACK FOOTER //
// ./src/Parts/CustomizedSnackbar/components/CustomizedSnackbar.js